import { makeVar } from '@apollo/client';
export const currentPage = makeVar('Agency');